import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const Spinner = () => (
  <div style={{
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    height: '100vh', background: '#0d0b1e', flexDirection: 'column', gap: '16px'
  }}>
    <div style={{
      width: '44px', height: '44px', borderRadius: '50%',
      border: '3px solid #2d1f6e', borderTop: '3px solid #7c3aed',
      animation: 'spin 1s linear infinite'
    }} />
    <p style={{ color: '#6b7280', fontFamily: 'DM Sans,sans-serif', fontSize: '0.9rem' }}>
      Caricamento...
    </p>
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

const PrivateRoute = ({ children, requiredRole }) => {
  const { user, authLoading } = useAuth();
  if (authLoading) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (requiredRole && user.ruolo !== requiredRole && user.ruolo !== 'admin' && !user.is_admin) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default PrivateRoute;
